import { statusMeta } from "./formatters";

function liveMeta(status) {
  if (!status) return { label: "Not tracking", tone: "muted" };
  return statusMeta(status);
}

function initials(name, userId) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  if (parts.length === 1 && parts[0].length >= 2) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  const id = String(userId || "").trim();
  return (id.slice(0, 2) || "?").toUpperCase();
}

export default function IndividualProfileCard({ userName, userId, status }) {
  const meta = liveMeta(status);
  const label = userName || userId || "User";

  return (
    <section className="pa-profile" aria-label="User">
      <div className="pa-profile__avatar" aria-hidden="true">{initials(userName, userId)}</div>
      <div>
        <h2 className="pa-profile__name">{label}</h2>
        <div className="pa-profile__state">
          <p className="pa-coverage__label">Current tracker state</p>
          <span className={`pa-state-chip pa-state-chip--${meta.tone} pa-state-chip--inline`}>
            <span className="pa-state-chip__label">
              <i className="pa-state-chip__dot" aria-hidden="true" />
              {meta.label}
            </span>
          </span>
          <span className="pa-states__hint">{status ? "Live session" : "No live session"}</span>
        </div>
      </div>
    </section>
  );
}
